// extracted by mini-css-extract-plugin
export const sectionHeaderContainer = "fleet-module--section-header-container--1DOyI";
export const busRow = "fleet-module--bus-row--23PZ3";
export const busTextAreaLeft = "fleet-module--bus-text-area-left--2w1fN";
export const busTextAreaRight = "fleet-module--bus-text-area-right--1_aHY";
export const busSubheading = "fleet-module--bus-subheading--3swj6";
export const busHeading = "fleet-module--bus-heading--1wArU";
export const busDescription = "fleet-module--bus-description--15-Ai";
export const busFeaturesLeft = "fleet-module--bus-features-left--2OUYx";
export const busFeaturesRight = "fleet-module--bus-features-right--18f7f";